import { ArrowLeft, BookOpenCheck, CheckCircle2, FileText, Lightbulb, PlayCircle, Target, Wrench } from 'lucide-react'
import { useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import StudentBackButton from '../components/StudentBackButton.jsx'
import { TRAINING_LEVELS, buildTrainingBreakdown } from '../student-training-assistant.js'

const samplePrompt = '课程项目：开发一个校园二手交易系统，包含登录、商品发布、搜索、订单管理、数据库存储、源码、截图和报告。'

export default function StudentTrainingAssistantPage() {
  const navigate = useNavigate()
  const [requirement, setRequirement] = useState('')
  const [levelKey, setLevelKey] = useState('zero')
  const [generated, setGenerated] = useState(false)
  const prompt = requirement.trim() || samplePrompt
  const report = useMemo(() => buildTrainingBreakdown(prompt, levelKey), [levelKey, prompt])

  return (
    <main className="page-container training-assistant-page">
      <StudentBackButton />
      <div className="student-project-rec-topbar">
        <button type="button" className="secondary-button" onClick={() => navigate('/learning')}>
          <ArrowLeft size={16} /> 学习路线
        </button>
        <button type="button" className="secondary-button" onClick={() => navigate('/growth')}>
          <ArrowLeft size={16} /> 我的成长
        </button>
      </div>

      <section className="training-assistant-hero">
        <span><BookOpenCheck size={16} /> 任务拆解</span>
        <h1>把课程任务拆成今天能开始的一步。</h1>
        <p>输入实训、课程设计或项目题目，先得到目标、交付物、步骤、技术栈和今日任务。这里保留旧组件能力，但入口已经下沉到学习相关页面。</p>
      </section>

      <section className="training-input-panel">
        <label>
          <span>练习/作业要求</span>
          <textarea value={requirement} onChange={(event) => setRequirement(event.target.value)} placeholder={samplePrompt} rows={8} />
        </label>
        <div className="training-level-options" aria-label="基础水平">
          {TRAINING_LEVELS.map((level) => (
            <button
              key={level.key}
              type="button"
              className={level.key === levelKey ? 'is-active' : ''}
              onClick={() => setLevelKey(level.key)}
            >
              <strong>{level.label}</strong>
              <span>{level.description}</span>
            </button>
          ))}
        </div>
        <button type="button" className="primary-button" onClick={() => setGenerated(true)}>
          <CheckCircle2 size={16} /> 生成拆解
        </button>
      </section>

      {generated ? (
        <section className="training-report">
          <section className="training-report-card"><h2><Target size={18} /> 目标</h2><p>{report.goal}</p></section>
          <section className="training-report-card"><h2><FileText size={18} /> 交付物</h2><ul>{report.deliverables.map((item) => <li key={item}>{item}</li>)}</ul></section>
          <section className="training-report-card"><h2><Wrench size={18} /> 建议工具</h2><ul>{report.stack.map((item) => <li key={item}>{item}</li>)}</ul></section>
          <section className="training-report-card"><h2><Lightbulb size={18} /> 避坑提醒</h2><ul>{report.pitfalls.map((item) => <li key={item}>{item}</li>)}</ul></section>
          <section className="training-report-card"><h2><PlayCircle size={18} /> 今日任务</h2><p>{report.todayTask}</p></section>
          <section className="training-report-card training-report-wide">
            <h2><BookOpenCheck size={18} /> 推进步骤</h2>
            <ol>
              {report.steps.map((step) => (
                <li key={step.title}>
                  <strong>{step.title}</strong>
                  <p>{step.detail}</p>
                  <span>{step.action}</span>
                </li>
              ))}
            </ol>
          </section>
          <div className="training-report-actions"><Link className="primary-button" to="/growth">回到我的成长</Link></div>
        </section>
      ) : null}
    </main>
  )
}
